module.exports = __webpack_public_path__ + "img/number-bg.43ef22ac.png";